export type UseClickActionsProps = {
    navigate: (path: string) => void;
};

export const useClickActions = ({ navigate }: UseClickActionsProps) => {
    type NavigateOnClickProps = {
        path: string;
        openNewTab?: boolean;
    };

    const navigateOnClick = ({ path, openNewTab = false }: NavigateOnClickProps) => {
        if (openNewTab) {
            window.open(path, '_blank', 'rel=noopener noreferrer');
            return;
        }

        navigate(path);
    };

    return {
        navigateOnClick,
    };
};
